import { NavContentLinkProps } from 'libs/contentful/props';
import NavSubLink from './NavSubLink';
import { ArrowRight } from '@1debit/icons';
import NavLink from 'components/shared/NavLink/NavLink';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { generateNavId } from 'components/MainNav/utils';

const NavSubMenu = ({ link, subMenu }: NavContentLinkProps) => {
  const { sys: linkSys, url, label, internalPage } = link;
  const { mainDescription, linkLabel, sublinksCollection, sys: subMenuSys } = subMenu!;
  const subLinks = sublinksCollection.items;
  const mainLinkId = generateNavId(link);

  return (
    <div className={'pt-6 pr-6 max-sm:pb-20'}>
      {/* Header */}
      <div className="flex flex-col gap-4 pb-5.5">
        <div className="flex flex-col gap-2">
          <p
            className="font-sans text-heading-md"
            id={`${mainLinkId}_title`}
            {...liveUpdateAttrs(linkSys?.id, 'label')}>
            {label}
          </p>
          {mainDescription && (
            <p
              className="font-serif text-sm"
              id={`${mainLinkId}_blurb`}
              {...liveUpdateAttrs(subMenuSys?.id, 'mainDescription')}>
              {mainDescription}
            </p>
          )}
        </div>
        <div {...liveUpdateAttrs(subMenuSys?.id, 'linkLabel')}>
          <NavLink
            id={`${mainLinkId}_learn_more`}
            level={0}
            className="font-sans text-label-saans font-semibold hover:text-current border-b-[1.5px] rounded-b-none border-transparent hover:border-current focus-visible:underline active:scale-none"
            href={url}
            cleanLinkText={linkLabel}
            internalPage={internalPage}>
            {linkLabel} <ArrowRight />
          </NavLink>
        </div>
      </div>

      {/* Links */}
      <div className="space-y-8 pt-4 pb-6">
        {subLinks.map(sublink => {
          return <NavSubLink key={sublink.link.label} idPrefix={mainLinkId} {...sublink} />;
        })}
      </div>
    </div>
  );
};

export default NavSubMenu;
